import React, { useState, useContext, useLayoutEffect, useEffect } from "react";
import ApiUser from "../../../app/api/admin/user/ApiUser";
import ApiRole from "../../../app/api/admin/role/ApiRole";
import Page from "../../modules/page";
import { ContextContent } from "../../modules/content/contentContext";
import InputWrapper from "../../components/input/__wrapper";
import InputText from "../../components/inputs/text";
import InputPassword from "../../components/inputs/password";
import InputCheckbox from "../../components/inputs/checkbox";
import InputDatetime from "../../components/inputs/datetime/datetime";
import Loader from "../../components/loader";

// Карточка пользователя: show / edit / create. Пароль обязателен на create,
// на edit пусто = не менять (backend UserRequest).
export default function UserShow({ ...other }) {
    return <Page ApiModel={ApiUser} {...other}>
        <UserShowContent/>
    </Page>;
}

function UserShowContent() {
    const contextContent = useContext(ContextContent);

    const [_id, set_id] = useState('');
    const [_username, set_username] = useState('');
    const [_name, set_name] = useState('');
    const [_email, set_email] = useState('');
    const [_password, set_password] = useState('');
    const [_passwordConfirmation, set_passwordConfirmation] = useState('');
    const [_roleIds, set_roleIds] = useState([]);
    const [_isActive, set_isActive] = useState(true);
    const [_created, set_created] = useState(null);
    const [_roles, set_roles] = useState(null); // null — справочник ролей ещё грузится

    useEffect(() => {
        (async () => {
            const api = ApiRole.Index();
            const data = await api.getResponse();
            set_roles(data ?? []);
        })();
    }, []);

    const toggleRole = (roleId, checked) => {
        set_roleIds((prev) => checked ? [...prev, roleId] : prev.filter((id) => id !== roleId));
    };

    contextContent._dataToServer.current = {
        username: _username,
        name: _name,
        email: _email,
        password: _password,
        password_confirmation: _passwordConfirmation,
        role_ids: _roleIds,
        is_active: _isActive,
    };
    // Backend-валидация требует эти поля в каждом update (UserRequest)
    contextContent._dataRequiredToServer.current = {
        username: _username,
        name: _name,
        email: _email,
    };

    useLayoutEffect(() => {
        contextContent._handleSetData.current = (data) => {
            set_id(data.id);
            set_username(data.username ?? '');
            set_name(data.name ?? '');
            set_email(data.email ?? '');
            set_password('');
            set_passwordConfirmation('');
            set_roleIds(data.role_ids ?? []);
            set_isActive(!!data.is_active);
            set_created(data.created_at);
            contextContent.setTitle(`Пользователь: ${data.username}`);
        };
        if (contextContent.isCreate) contextContent.setTitle('Новый пользователь');
        contextContent.doLoad();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const readOnly = !contextContent.isCreateOrEdit;
    const errors = contextContent.errors ?? {};

    return <>
        {!contextContent.isCreate ?
            <InputWrapper>
                <InputText className="input_wf" value={_id} readOnly={true}>id</InputText>
            </InputWrapper> : null}

        <InputWrapper>
            <InputText className="input_wf" value={_username} readOnly={readOnly} errors={errors.username}
                autoComplete="off" onChange={(e) => set_username(e.target.value)}>Логин</InputText>
        </InputWrapper>
        <InputWrapper>
            <InputText className="input_wf" value={_name} readOnly={readOnly} errors={errors.name}
                onChange={(e) => set_name(e.target.value)}>Имя</InputText>
        </InputWrapper>
        <InputWrapper>
            <InputText className="input_wf" value={_email} readOnly={readOnly} errors={errors.email}
                onChange={(e) => set_email(e.target.value)}>Email</InputText>
        </InputWrapper>

        {contextContent.isCreateOrEdit ? <>
            <InputWrapper>
                <InputPassword className="input_wf" value={_password} errors={errors.password}
                    placeholder={contextContent.isCreate ? 'Пароль' : 'Пусто — оставить прежний'}
                    autoComplete="new-password"
                    onChange={(e) => set_password(e.target.value)}>Пароль</InputPassword>
            </InputWrapper>
            <InputWrapper>
                <InputPassword className="input_wf" value={_passwordConfirmation}
                    placeholder="Повторите пароль" autoComplete="new-password"
                    onChange={(e) => set_passwordConfirmation(e.target.value)}>Подтверждение пароля</InputPassword>
            </InputWrapper>
        </> : null}

        <InputWrapper>
            {/* Справочник ролей грузится отдельным запросом от самой карточки — без индикатора
                блок чекбоксов какое-то время выглядит как «ролей в системе нет». */}
            {_roles === null
                ? <Loader text="Загрузка ролей…"/>
                : _roles.map((role) => (
                    <InputCheckbox key={role.id} value={_roleIds.includes(role.id)} readOnly={readOnly}
                        onChange={(e) => toggleRole(role.id, e.target.checked)}>{role.label || role.slug}</InputCheckbox>
                ))}
        </InputWrapper>
        <InputWrapper>
            <InputCheckbox value={_isActive} readOnly={readOnly}
                onChange={(e) => set_isActive(e.target.checked)}>Активен</InputCheckbox>
        </InputWrapper>

        {!contextContent.isCreate ? <>
            <InputWrapper>
                <InputDatetime className="input_wf" value={_created} readOnly={true}>Создан</InputDatetime>
            </InputWrapper>
        </> : null}
    </>;
}
